// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SupportRequest  {
    _originalTypeClassName = "Loom.BO.SupportRequest";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SupportRequest.translate = translateService;
}
this.Attachments = [];
this.Id = null;
this.RequestDescription = null;
this.CreatedOn = null;
this.ClickUpTaskId = null;
this.Title = null;
this.ClickUpUrl = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
RequestDescription:any;
CreatedOn:any;
ClickUpTaskId:any;
Title:any;
ClickUpUrl:any;
CreatedBy:any;
Attachments:any;
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setAttachments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Attachments == null) $this.Attachments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Attachments.length > 0) {
                    Domain.SupportRequest.removeAttachments($this, $this.Attachments[0]);
                }

                Domain.SupportRequest.addManyAttachments($this, copyItems);
            }
static addManyAttachments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SupportRequest.addAttachments($this, items[i]);
                }
            }
static addAttachments = ($this, item) => {
                if ($this.Attachments == null) $this.Attachments = [];
                if (item == null || $this.Attachments.indexOf(item) > -1) return;
                $this.Attachments.push(item);
}
static addRangeAttachments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SupportRequest.addAttachments($this, item));
            }
static removeAttachments = ($this, item) => {
                if ($this == null || $this.Attachments == null || $this.Attachments.indexOf(item) === -1) return;
                var _index = $this.Attachments.indexOf(item);
                $this.Attachments.splice(_index, 1);
}
static clearAttachments = ($this) => { $this.Attachments = null; }

static GetClickUpUrl($this: any): any{return CLMS.Framework.String.Format("https://app.clickup.com/t/{0}", $this?.ClickUpTaskId);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}